import {
  SuggestedActionCard as SharedSuggestedActionCard,
  defaultChatIcons,
} from "@sudowrite/shared-chat";
import type { SuggestedAction } from "src/stores/persistentChatStore";

interface SuggestedActionCardProps {
  action: SuggestedAction;
  currentMode: "write" | "chat";
  /** Matches composer mode switcher label for write mode. */
  writeModeBadgeLabel?: string;
  onActionClick: (message: string, switchToWrite: boolean) => void;
}

export const SuggestedActionCard = ({
  action,
  currentMode,
  writeModeBadgeLabel = "Allow edits",
  onActionClick,
}: SuggestedActionCardProps) => {
  return (
    <SharedSuggestedActionCard
      action={action}
      currentMode={currentMode}
      writeModeBadgeLabel={writeModeBadgeLabel}
      icons={defaultChatIcons}
      onActionClick={onActionClick}
    />
  );
};
